import { render, staticRenderFns } from "./questionA.vue?vue&type=template&id=843f7afe&scoped=true"
import script from "./questionA.vue?vue&type=script&lang=js"
export * from "./questionA.vue?vue&type=script&lang=js"
import style0 from "./questionA.vue?vue&type=style&index=0&id=843f7afe&prod&lang=css"
import style1 from "./questionA.vue?vue&type=style&index=1&id=843f7afe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843f7afe",
  null
  
)

export default component.exports